var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiBlackCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2726 9L12.8187 6.4548C12.9876 6.28592 13.0825 6.05688 13.0825 5.81805C13.0825 5.57922 12.9876 5.35018 12.8187 5.1813C12.6498 5.01242 12.4208 4.91755 12.1819 4.91755C11.9431 4.91755 11.7141 5.01242 11.5452 5.1813L9 7.7274L6.4548 5.1813C6.28592 5.01242 6.05688 4.91755 5.81805 4.91755C5.57922 4.91755 5.35018 5.01242 5.1813 5.1813C5.01242 5.35018 4.91755 5.57922 4.91755 5.81805C4.91755 6.05688 5.01242 6.28592 5.1813 6.4548L7.7274 9L5.1813 11.5452C5.01242 11.7141 4.91755 11.9431 4.91755 12.1819C4.91755 12.4208 5.01242 12.6498 5.1813 12.8187C5.35018 12.9876 5.57922 13.0825 5.81805 13.0825C6.05688 13.0825 6.28592 12.9876 6.4548 12.8187L9 10.2726L11.5452 12.8187C11.7141 12.9876 11.9431 13.0825 12.1819 13.0825C12.4208 13.0825 12.6498 12.9876 12.8187 12.8187C12.9876 12.6498 13.0825 12.4208 13.0825 12.1819C13.0825 11.9431 12.9876 11.7141 12.8187 11.5452L10.2726 9ZM9 18C4.0293 18 0 13.9707 0 9C0 4.0293 4.0293 0 9 0C13.9707 0 18 4.0293 18 9C18 13.9707 13.9707 18 9 18Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiBlackCross);
export default __webpack_public_path__ + "static/media/HIBlackCross.c3f4fa94b0bd3e3cc6b954239a7448ff.svg";
export { ForwardRef as ReactComponent };